// extracted by mini-css-extract-plugin
export default {"header":"ReportsHeader_header__7dG4Q","dashboardTop":"ReportsHeader_dashboardTop__4hiq0"};